var React = require('react');

function DeviceUsersIcon (props) {
    return React.createElement("svg",props,React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M9 3h12.75a.75.75 0 0 1 .75.75v13.5a.75.75 0 0 1-.75.75H16v1.5h5.75A2.25 2.25 0 0 0 24 17.25V3.75a2.25 2.25 0 0 0-2.25-2.25H9a2.25 2.25 0 0 0-2.25 2.25V7h1.5V3.75A.75.75 0 0 1 9 3zm7.75 18a.75.75 0 0 0 0 1.5h3.5a.75.75 0 0 0 0-1.5h-3.5zm-4.378 2c.989 0 1.81-.746 1.593-1.634a6.99 6.99 0 0 0-1.9-3.316 7.175 7.175 0 0 0-2.324-1.517 7.309 7.309 0 0 0-5.482 0 7.175 7.175 0 0 0-2.324 1.517 6.991 6.991 0 0 0-1.9 3.316C-.183 22.254.64 23 1.628 23h10.744zM7 15a3 3 0 1 0 0-6 3 3 0 0 0 0 6z","fill":"#E8EFFF"}));
}

DeviceUsersIcon.defaultProps = {"width":"24","height":"24","viewBox":"0 0 24 24","fill":"none"};

module.exports = DeviceUsersIcon;

DeviceUsersIcon.default = DeviceUsersIcon;
